export default [
  'a',
  'abaft',
  'aboard',
  'about',
  'above',
  'absent',
  'across',
  'afore',
  'after',
  'against',
  'along',
  'alongside',
  'amid',
  'amidst',
  'among',
  'amongst',
  'an',
  'anenst',
  'anti',
  'apropos',
  'apud',
  'around',
  'as',
  'aside',
  'astride',
  'at',
  'athwart',
  'atop',
  'barring',
  'before',
  'behind',
  'below',
  'beneath',
  'beside',
  'besides',
  'between',
  'beyond',
  'but',
  'by',
  'circa',
  'concerning',
  'considering',
  'despite',
  'down',
  'during',
  'except',
  'excepting',
  'excluding',
  'failing',
  'following',
  'for',
  'forenenst',
  'from',
  'given',
  'in',
  'including',
  'inside',
  'into',
  'lest',
  'like',
  'mid',
  'midst',
  'minus',
  'modulo',
  'near',
  'next',
  'notwithstanding',
  'of',
  'off',
  'on',
  'onto',
  'opposite',
  'out',
  'outside',
  'over',
  'pace',
  'past',
  'per',
  'plus',
  'pro',
  'qua',
  'regarding',
  'round',
  'sans',
  'save',
  'since',
  'than',
  'the',
  'through',
  'throughout',
  'till',
  'times',
  'to',
  'toward',
  'towards',
  'under',
  'underneath',
  'unlike',
  'until',
  'unto',
  'up',
  'upon',
  'versus',
  'via',
  'vice',
  'with',
  'within',
  'without',
  'worth',
]
